import { render } from "./KanjiCard.vue?vue&type=template&id=7feb9ab2"
import script from "./KanjiCard.vue?vue&type=script&lang=js"
export * from "./KanjiCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\cram_srs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__